<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img src="@/assets/images/touxiang.jpg" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1" v-if="!userInfo.nickname">花开花落</div>
            <div class="name line1" v-else>{{ userInfo.nickname }}</div>
            <!-- <div class="member acea-row row-middle" v-if="userInfo.vip">
							<img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
						</div> -->
            <div class="member acea-row row-middle">
              <img src="@/assets/images/licai/VIP.png" />
            </div>
          </div>
          <div style="color:#fff;font-size:14px;">
            {{ userInfo.is_auth == 1 ? "已实名" : "未实名" }}
          </div>
        </div>
      </div>
      <!-- <span
        class="iconfont icon-shezhi"
        @click="$router.push({ path: '/' })"
      ></span> -->
    </div>
    <div class="user_con">
      <div class="user_con_top">
        <div class="user_con_top_left">
          <p class="">￥{{ userInfo.money }}</p>
          <p class="">我的余额</p>
        </div>
        <div class="user_con_top_left">
          <p class="">{{ userInfo.tadditional }}</p>
          <p class="">增值收益</p>
        </div>
      </div>
      <div class="user_con_mid">
        <p class="user_con_mid_tit">{{ funcList.title }}</p>
        <div class="user_con_mid_block">
          <div
            class="user_con_mid_line"
            v-for="item in conList"
            :key="item.id"
            @click="dianji(item.id)"
          >
            <img :src="item.img" />
            <p class="">{{ item.tit }}</p>
          </div>
        </div>
        <!-- <img class="yaoqing" src="../../assets/images/licai/yaoqing.png"> -->
      </div>
      <div class="user_con_select">
        <!-- <div class="user_con_select_list">
          <p
            style="display: flex;
    align-items: center;"
          >
            <img
              style="width: 15px;
    margin-right: 7px;"
              :src="funcList.icon"
              alt=""
            />{{ funcList.more }}
          </p>
          <img :src="funcList.imgs" />
        </div> -->
        <div
          class="user_con_select_list"
          v-for="item in moreList"
          :key="item.id"
          @click="goTo(item.id)"
        >
          <p
            class=""
            style="display: flex;
    align-items: center;"
          >
            <img
              style="width: 25px;
    margin-right: 10px;"
              :src="item.icon"
              alt=""
            />{{ item.text }}
          </p>
          <img :src="item.imgs" />
        </div>
      </div>
    </div>
    <!-- <SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type"></SwitchWindow> -->
    <!-- <GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow" :generalContent="generalContent"></GeneralWindow> -->
  </div>
</template>

<script>
import local from "@/utils/local";
import { getUser, getMenuUser, getMyUserInfo } from "@api/user";
import { isWeixin } from "@utils";
// import SwitchWindow from "@components/SwitchWindow";
// import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    // SwitchWindow,
    // GeneralWindow
  },
  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      },
      funcList: {
        title: "",
        stimg: "/h5/img/yaoqing.04e5fd93.png",
        icon: require("@/assets/images/licai/yq1.png"),
        more: "更多服务",
        imgs:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
      },
      moreList: [
        // {
        //   id: 1,

        //   icon: require("@/assets/images/licai/yq2.png"),
        //   text: "新手帮助",
        //   imgs:
        //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        // },
        {
          id: 2,

          icon: require("@/assets/images/licai/dh4.png"),
          text: "安全保障",
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },

        {
          id: 4,
          text: "客服中心",

          icon: require("@/assets/images/licai/dh6.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        {
          id: 5,
          text: "我要充值",

          icon: require("@/assets/images/licai/dh7.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        {
          id: 6,
          text: "我要提现",

          icon: require("@/assets/images/licai/dh8.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        // {
        //   id: 7,
        //   text: "我的资产",

        //   icon: require("@/assets/images/licai/dh9.png"),
        //   imgs:
        //     "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        // },
        {
          id: 10,
          text: "修改支付密码",

          icon: require("@/assets/images/licai/dh20.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        {
          id: 11,
          text: "修改登录密码",

          icon: require("@/assets/images/licai/dh21.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        {
          id: 31,
          text: "提现记录",

          icon: require("@/assets/images/licai/dh31.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        {
          id: 32,
          text: "充值记录",

          icon: require("@/assets/images/licai/dh32.png"),
          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        },
        {
          id: 8,
          text: "退出登录",

          icon: require("@/assets/images/licai/dh10.png"),

          imgs:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAchJREFUWEftls9LG0EUx98MuRj8CwIFYeatyR/gsf4JHvwjbGu8pHoyoqWWnktjaaFQelDwxz+gUs8KonhM2EkCUnrILQiesvstWzawSGx2dlcXxL0Ny/D5zHtv3jxBOX8iZz49C8SKgOu6G0R0yszHWacslkCr1XonpawR0Sozf8lSwkYgiAIB+Oz7/lq5XL7JQiSWQLPZnC4UCt8BvAyhh0RUZ+bLtBKxBIYQY8xXAK/D9R8hxFut9V4aCSuBAGSMWQLQGEIBrDuOs5lUwlogAHU6nVnP834QkQrBB1LKFaXUta1IIoEA0uv1Jvv9/g4RzYVQV0r5Ril1YiORWCBSFx8A1CPQGjN/iiuRWiAAtdvteQDbACaCtRDiZ7FYrJZKpdtxIpkIBJButzvled4+gJkQeiWlXFBKnf9PIjOBSEq+AXgVgb5g5t/3STwdgVxTkGsRGmPyuYajGhGARcdxfo27etH/iYow11Z89zEiog1mfm9z6sQRGPEcL2utd5PC/3XNOJtHDSSDwWCtUqlcxNmfuhOGM+FwJGv4vl9/1JHMdd2PRFQVQtS11ltpT21dA+FYfsbMR1nCY9dA1lDrCDwLPGQE/gJyat0hazHEigAAAABJRU5ErkJggg=="
        }
      ],
      conList: [
        {
          id: 0,
          img: require("@/assets/images/licai/cygn1.png"),
          tit: "财务明细"
        },
        {
          id: 1,
          img: require("@/assets/images/licai/cygn2.png"),
          tit: "我的团队"
        },
        {
          id: 2,
          img: require("@/assets/images/licai/cygn3.png"),
          tit: "银行卡"
        },
        {
          id: 3,
          img: require("@/assets/images/licai/cygn4.png"),
          tit: "实名认证"
        },
        {
          id: 4,
          img: require("@/assets/images/licai/cygn5.png"),
          tit: "日利宝"
        },
        {
          id: 5,
          img: require("@/assets/images/licai/cygn6.png"),
          tit: "我的投资"
        },
        {
          id: 6,
          img: require("@/assets/images/licai/cygn7.png"),
          tit: "积分商城"
        },
        {
          id: 7,
          img: require("@/assets/images/licai/cygn8.png"),
          tit: "邀请好友"
        }
      ]
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  created() {
    getMyUserInfo().then(res => {
      console.log(res.data, "oooooo");
      this.userInfo = res.data.data;
    });
  },
  mounted: function() {
    this.isWeixin = isWeixin();
  },
  methods: {
    onWithdrawal() {
      this.$router.push({
        path: "/CzContent"
      });
    },
    onJF() {
      this.$router.push({
        path: "/member_transform"
      });
    },
    onRecharge() {
      this.$router.push({
        path: "/"
      });
    },
    goTo: function(lists) {
      switch (lists) {
        case 1:
          this.$router.push({ name: "article_detail", query: { id: 16 } });
          break;
        case 2:
          this.$router.push({ name: "article_detail", query: { id: 22 } });
          break;
        case 4:
          this.$router.push({
            path: "/member_fans"
          });
          break;
        case 5:
          this.onWithdrawal();
          break;
        case 6:
          this.$router.push({
            path: "/txCash"
          });
          break;
        case 7:
          this.$router.push({
            path: `/my-assets`,
            query: { tmoney: this.userInfo.tmoney }
          });
          break;
        case 10:
          this.$router.push({
            path: "/PayPass"
          });
          break;
        case 11:
          this.$router.push({
            path: "/LoginPass"
          });
          break;
        case 31:
          this.$router.push({
            path: "/withdrawal_record"
          });
          break;
        case 32:
          this.$router.push({
            path: "/deposit_record"
          });
          break;

        case 8:
          this.$store.commit("LOGOUT");
          local.clear();
          this.$router.push({
            path: `/login`
          });
          break;
        default:
          this.$router.push({
            path: "/"
          });
          break;
      }
    },
    dianji: function(id) {
      switch (id) {
        case 0:
          this.$router.push({
            path: "/moneyDetail"
          });
          break;
        case 1:
          this.$router.push({
            path: "/team"
          });
          break;
        case 7: //邀请好友
          this.$router.push({
            path: "/invitation"
          });
          break;
        case 3:
          this.$router.push({
            path: "/memmber_business"
          });
          break;
        case 4:
          this.$router.push({
            path: "/rilibaoindex"
          });
          break;
        case 6:
          this.$router.push({
            path: "/JfList"
          });
          break;
        case 5:
          this.$router.push({
            path: "/myInvest"
          });
          break;
        case 2:
          this.$router.push({
            path: "/bank"
          });
          break;
        default:
          this.$router.push({
            path: "/"
          });
          break;
      }
    },
    // 安全保障
    anquan: function() {
      this.$router.push({
        path: "/anquan"
      });
    },
    // 新手帮助
    news: function() {
      this.$router.push({
        path: "/news"
      });
    },
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      this.$router.push({
        path: url
      });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      // 卡密激活
      if (url == "/user/user_coupon") {
        this.$router.push({
          path: "/user/get_coupon"
        });
        return;
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({
          mes: "您还不是客服！！"
        });
      }
      this.$router.push({
        path: this.MyMenus[index].wap_url
      });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style scoped>
.user {
  font-size: 14px;
}
.user_con_select {
  padding: 10px;
  border-radius: 8px;
  margin-top: 10px;
  background-color: #ffffff;
}
.user_con_select_tit {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  padding: 8px 15px;
}
.user_con_select_list {
  display: flex;
  align-items: center;
  padding: 15px 15px;
  border-bottom: 1px solid #eee;
}
.user_con_select_list img {
  margin-left: auto;
  width: 20px;
}
.user_con_select_list p {
  font-size: 14px;
  color: #000000;
}
.user_con_mid {
  margin-top: 13%;
  background-color: #fff;
  padding: 15px;
}
.user_con_mid_tit {
  font-size: 14px;
  color: #333;
}
.user_con_mid_block {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: baseline;
  margin-top: 10px;
}

.user_con_mid_block .user_con_mid_line:nth-child(2) img {
  height: 22px;
}
.yaoqing {
  width: 100%;
}
.user_con_mid_line {
  width: 22%;
  margin-bottom: 12px;
}
.user_con_mid_line img {
  width: 34%;
  display: block;
  margin: 0 auto;
}
.user_con_mid_line p {
  text-align: center;
  margin-top: 8px;
}
.user_con_top_left {
  width: 50%;
}
.user_con_top_left:first-child {
  border-right: 1px solid rgb(162 150 150 / 50%);
}
.user_con_top_left p {
  text-align: center;
}
/* .user_con_top_but button{margin-left: 15px;} */
.user_con_top {
  padding: 14px;
  background: #ffffff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  position: absolute;
  width: 92%;
  left: 4%;
  top: -10%;
}
.user_con_top_but {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px !important;
}
.user_con_top_but button:first-child {
  width: 43px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #cf4948;
  margin-right: 14px;
  border-radius: 10px;
  color: #cf4948;
  line-height: 18px;
  text-align: center;
}
.user_con_top_but button:last-child {
  width: 43px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #1664FC;
  border-radius: 10px;
  color: #1664FC;
  text-align: center;
  line-height: 18px;
}
.user_con {
  width: 100%;
  background-color: #f2f1f6;
  padding: 0px 15px;
  position: relative;
  padding-bottom: 90px !important;
}
.footer-line-height {
  height: 1rem;
}

.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #334eec;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 14px;
  padding: 0 0.08rem;
  border: 1px solid #334eec;
}

.pictrue {
  position: relative;
}

.switch-h5 {
  margin-left: 0.2rem;
}
.user {
  background-color: rgb(245, 245, 245);
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: #4aa8fa;
  border-radius: 50px;
  font-size: 14px;
  border: 1px solid #4aa8fa;
  color: #ffffff;
  width: 50%;
  text-align: center;
  margin-top: 10px;
}
</style>
